const noSensorsOverlay = $blurredContainer => {

  $blurredContainer.addClass('overlay overlay--blurred');

  $('.app-contents').css('position', 'relative');
  $('.app-contents').children(':last-child').after(`
      
      <div class="modal is-open" style="margin-top: 20px; background: transparent;">
        <div class="modal-content">
          <div class="modal__content">
            <h2 class="heading--regular">Welcome to Temp Stick!</h2>
            <p class="lead">Your account doesn't have any sensors, to get started we'll need to set one up.</p>

            <button class="button button--medium" type="button" data-for="setup-sensor">
              <i class="far fa-plus-circle"></i> Add New Temp Stick
            </button>
            
          </div>         
        </div>
      </div>    
      `);

  $('.app-contents button[data-for="setup-sensor"]').on('click', e => {

    window.location.href = `${window.site.home}/setup`;

  });

};

export default noSensorsOverlay;
